import * as React from 'react';
import dayjs from 'dayjs';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { Box } from '@mui/material';

export default function CustomDatePicker2({label, value, name, handleOnChange, minDate, disabled = false}) {
    const today = dayjs();
  return (
    <Box  sx={{ '& .MuiTextField-root': { width: '100%', textAlign: 'left' } }}>
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['DatePicker']}>
        
        <DatePicker 
            size="small"
          label={label}
          format="DD/MM/YYYY"
          value={value ? dayjs(value) : null}
          slotProps={{ textField: { size: 'small' } }}
          disabled={disabled}
          minDate={minDate ? dayjs(minDate) : null} 
          maxDate={today}
          onChange={(newValue) => {
            handleOnChange(dayjs(newValue).format('YYYY/MM/DD'), name);
          }}
          
        />
      </DemoContainer>
    </LocalizationProvider>
    </Box>
  );
}
